export interface IGetRailConfig {
  railName: string | undefined
  // slidesCount?: number
}

export const getRailConfig = ({ railName }: IGetRailConfig) => {
  switch (railName) {
    case 'main':
      return {
        media: {
          slidesPerView: 2.1,
          spaceBetween: 11,
        },
        regular: {
          slidesPerView: 3,
          spaceBetween: 0,
          slidesPerGroup: 3,
        },
      }
    case 'poster_regular':
      return {
        media: {
          spaceBetween: 12,
          slidesPerView: 2,
        },
        regular: {
          slidesPerView: 7,
          slidesPerGroup: 7,
          spaceBetween: 25,
        },
        size: {
          railSize: 14,
          pageSize: 8,
        },
        '430': { slidesPerView: 4.6, slidesPerGroup: 4, spaceBetween: 12 },
        '769': { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15 },
        '1280': { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
        '1440': { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 25 },
      }
    case 'poster_small':
      return {
        media: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        regular: {
          slidesPerView: 7,
          slidesPerGroup: 7,
          spaceBetween: 25,
        },
        size: {
          railSize: 14,
          pageSize: 8,
        },
      }
    case 'shows':
      return {
        media: {
          slidesPerView: 2.2,
          spaceBetween: 12,
        },
        regular: {
          slidesPerView: 7,
          slidesPerGroup: 7,
          spaceBetween: 25,
        },
        size: {
          railSize: 14,
          pageSize: 8,
        },
      }
    case 'episodes':
    case 'movies':
    case 'catchup':
    case 'personal_rail':
    case '16x9_regular':
      return {
        media: {
          slidesPerView: 1.6,
          spaceBetween: 12,
        },
        regular: {
          slidesPerView: 5,
          spaceBetween: 25,
          slidesPerGroup: 5,
        },
        size: {
          railSize: 10,
          pageSize: 6,
        },
        '430': { slidesPerView: 1.6, slidesPerGroup: 1, spaceBetween: 12 },
        '769': { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 },
        '1280': { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
        '1440': { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 25 },
      }
    default:
      return {
        media: {
          slidesPerView: 1.6,
          spaceBetween: 0,
        },
        regular: {
          slidesPerView: 7.5,
          spaceBetween: 0,
          slidesPerGroup: 7,
        },
        size: {
          railSize: 14,
          pageSize: 8,
        },
      }
  }
}
